// @ts-nocheck
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FileText, ArrowLeft } from "lucide-react";

export default function TermsPage() {
    useEffect(() => {
        document.title = "Όροι Χρήσης — Orion Intelligence";
        window.scrollTo(0, 0);
        return () => { document.title = "Orion Intelligence"; };
    }, []);

    const sectionStyle = {
        background: "rgba(255, 255, 255, 0.03)",
        borderColor: "rgba(255, 255, 255, 0.06)"
    };

    const headingColor = "#19e6ff";

    return (
        <div
            className="min-h-screen text-white"
            style={{
                background: `radial-gradient(ellipse at 30% 0%, rgba(25, 230, 255, 0.05), transparent 50%),
                             radial-gradient(ellipse at 70% 100%, rgba(139, 34, 82, 0.06), transparent 50%),
                             linear-gradient(170deg, #070b14, #0a0f1e)`
            }}
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

                {/* Header */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="mb-12"
                >
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors mb-8"
                    >
                        <ArrowLeft size={16} />
                        Επιστροφή στην αρχική
                    </Link>

                    <div className="flex items-center gap-4 mb-6">
                        <div
                            className="p-3 rounded-2xl"
                            style={{ background: "rgba(25, 230, 255, 0.08)", border: "1px solid rgba(25, 230, 255, 0.15)" }}
                        >
                            <FileText size={28} style={{ color: headingColor }} />
                        </div>
                        <div>
                            <h1 className="text-3xl md:text-4xl font-black tracking-tight">
                                Όροι Χρήσης
                            </h1>
                            <p className="text-sm text-slate-400 mt-1 uppercase tracking-widest font-medium">
                                Orion Intelligence
                            </p>
                        </div>
                    </div>

                    <div className="h-px w-full bg-gradient-to-r from-cyan-500/30 via-transparent to-transparent" />
                </motion.div>

                {/* Content */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="space-y-8"
                >
                    {/* Intro */}
                    <section className="rounded-2xl border p-6 md:p-8" style={sectionStyle}>
                        <p className="text-slate-300 leading-relaxed">
                            Η ιστοσελίδα <strong className="text-white">www.orionintelligence.net</strong> είναι
                            ιστοσελίδα που δημιούργησε η ατομική επιχείρηση{" "}
                            <strong className="text-white">ΔΕΛΛΙΟΣ ΔΗΜΗΤΡΙΟΣ ΤΟΥ ΑΘΑΝΑΣΙΟΥ</strong> (δ.τ.{" "}
                            <strong className="text-white">Orion Intelligence</strong>), η οποία εδρεύει στον Πολύγυρο Χαλκιδικής,
                            με ΑΦΜ 135602991 (ΔΟΥ Πολυγύρου) και αριθμό Γ.Ε.ΜΗ. 192625657000, και εκπροσωπείται νόμιμα, με ηλεκτρονική
                            διεύθυνση επικοινωνίας{" "}
                            <a href="mailto:support@orionintelligence.net" className="hover:underline" style={{ color: headingColor }}>
                                support@orionintelligence.net
                            </a>.
                        </p>
                    </section>

                    {/* Section 1 */}
                    <section className="rounded-2xl border p-6 md:p-8" style={sectionStyle}>
                        <h2 className="text-lg font-bold mb-4 flex items-center gap-2" style={{ color: headingColor }}>
                            <span className="text-xs font-mono opacity-50 mr-1">01</span>
                            Γενικοί Όροι & Αποδοχή
                        </h2>
                        <p className="text-slate-300 leading-relaxed">
                            Οι κάτωθι όροι και προϋποθέσεις θα εφαρμόζονται για τη χρήση της ιστοσελίδας
                            της εταιρείας Orion Intelligence, η οποία βρίσκεται στην ηλεκτρονική διεύθυνση{" "}
                            <strong className="text-white">www.orionintelligence.net</strong>, καθώς και για τις
                            εφαρμογές λογισμικού που παρέχονται μέσω αυτής (συμπεριλαμβανομένων, ενδεικτικά, των{" "}
                            <em className="text-white">CaseMaster</em>, <em className="text-white">Lawyer Anywhere</em>{" "}
                            και κάθε μελλοντικού προϊόντος). Η χρήση του site προϋποθέτει την ανεπιφύλακτη αποδοχή
                            των παρακάτω όρων, χωρίς καμία εξαίρεση, τους οποίους θα πρέπει να διαβάσετε
                            προσεκτικά. Απαγορεύεται ρητά η χρήση των ιστοσελίδων και εφαρμογών της
                            Orion Intelligence σε περίπτωση μη αποδοχής των παρόντων όρων χρήσης. Η χρήση
                            των ως άνω ιστοσελίδων και υπηρεσιών υποδηλώνει την πλήρη αποδοχή των όρων και
                            προϋποθέσεων που έχει θέσει η Orion Intelligence.
                        </p>
                    </section>

                    {/* Section 2 */}
                    <section className="rounded-2xl border p-6 md:p-8" style={sectionStyle}>
                        <h2 className="text-lg font-bold mb-4 flex items-center gap-2" style={{ color: headingColor }}>
                            <span className="text-xs font-mono opacity-50 mr-1">02</span>
                            Υποχρεώσεις Επισκεπτών / Χρηστών
                        </h2>
                        <p className="text-slate-300 leading-relaxed mb-4">
                            Οι επισκέπτες και χρήστες του διαδικτυακού τόπου συμφωνούν ότι:
                        </p>
                        <ul className="space-y-3 text-sm text-slate-400">
                            {[
                                "Θα χρησιμοποιούν τα πραγματικά τους στοιχεία (επώνυμο, όνομα, διεύθυνση, e-mail) στις φόρμες επικοινωνίας και εγγραφής.",
                                "Θα χρησιμοποιούν το site και τις εφαρμογές σύμφωνα με τον νόμο και τα χρηστά ήθη και δε θα προβαίνουν σε ενέργειες ή παραλείψεις που μπορεί να προκαλέσουν βλάβη σε αυτό αλλά και σε οποιονδήποτε άλλο χρήστη.",
                                "Ειδικότερα απαγορεύεται η χρήση των υπηρεσιών της Εταιρείας για οποιοδήποτε μη νόμιμο σκοπό, περιλαμβανομένων αλλά μη περιοριζόμενων σε: δημοσίευση παράνομου περιεχομένου, αρχείων προερχόμενων από κλοπή, αναδημοσίευση περιεχομένου χωρίς την απαραίτητη άδεια του εκδότη, αποστολή μαζικής αλληλογραφίας (spam) χωρίς την έγκριση των παραληπτών, ή απόπειρα παραβίασης συστημάτων ασφαλείας.",
                                "Κάθε χρήστης που χρησιμοποιεί ή προτρέπει μέσω links ή άλλων μέσων σε πρακτικές που εμπίπτουν στα παραπάνω, μπορεί να οδηγηθεί σε άμεση διακοπή πρόσβασης. Η Orion Intelligence διατηρεί το δικαίωμα να διεκδικήσει αποζημίωση από τυχόν ζημία, θετική και αποθετική, που ήθελε υποστεί εκ της μη σύννομης συμπεριφοράς."
                            ].map((item, i) => (
                                <li key={i} className="flex items-start gap-3">
                                    <span className="w-1.5 h-1.5 rounded-full mt-2 shrink-0" style={{ background: headingColor }} />
                                    <span className="leading-relaxed">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </section>

                    {/* Section 3 */}
                    <section className="rounded-2xl border p-6 md:p-8" style={sectionStyle}>
                        <h2 className="text-lg font-bold mb-4 flex items-center gap-2" style={{ color: headingColor }}>
                            <span className="text-xs font-mono opacity-50 mr-1">03</span>
                            Πνευματική Ιδιοκτησία & Εμπορικά Σήματα
                        </h2>
                        <p className="text-slate-300 leading-relaxed mb-4">
                            Τα πνευματικά δικαιώματα του περιεχομένου (συμπεριλαμβανομένων κειμένων, γραφικών,
                            εικόνων, φωτογραφιών, πηγαίου κώδικα και λογισμικού) και των υπηρεσιών του site
                            που έχουν εισαχθεί ή θα εισαχθούν στο διαδίκτυο, προστατεύονται από τους ελληνικούς,
                            κοινοτικούς και διεθνείς νόμους περί πνευματικής ιδιοκτησίας και ανήκουν αποκλειστικά
                            στην Orion Intelligence. Απαγορεύεται αυστηρά η οποιαδήποτε αντιγραφή, αναπαραγωγή,
                            αναμετάδοση ή αντίστροφη μηχανική (reverse engineering) του υλικού, χωρίς έγγραφη
                            άδεια της εταιρείας.
                        </p>
                        <p className="text-slate-300 leading-relaxed">
                            Τα ονόματα, εικόνες, λογότυπα και διακριτικά γνωρίσματα που αντιπροσωπεύουν
                            τα εμπορικά σήματα <strong className="text-white">Orion Intelligence</strong>,{" "}
                            <strong className="text-white">CaseMaster</strong>,{" "}
                            <strong className="text-white">Lawyer Anywhere</strong> ή τρίτα μέρη,
                            είναι αποκλειστικά σήματα της Orion Intelligence ή τρίτων μερών, προστατευόμενα
                            από τους σχετικούς νόμους. Η εμφάνισή τους στον διαδικτυακό τόπο δε θα πρέπει
                            κατά κανένα τρόπο να εκληφθεί ως μεταβίβαση ή εκχώρηση άδειας χρήσης τους.
                        </p>
                    </section>

                    {/* Section 4 */}
                    <section className="rounded-2xl border p-6 md:p-8" style={sectionStyle}>
                        <h2 className="text-lg font-bold mb-4 flex items-center gap-2" style={{ color: headingColor }}>
                            <span className="text-xs font-mono opacity-50 mr-1">04</span>
                            Συνδρομές & Πληρωμές (SaaS)
                        </h2>
                        <p className="text-slate-300 leading-relaxed mb-4">
                            Ορισμένες από τις υπηρεσίες της Orion Intelligence παρέχονται βάσει μοντέλου
                            συνδρομής (Software as a Service – SaaS). Οι πληρωμές διεκπεραιώνονται με
                            ασφάλεια μέσω της πλατφόρμας <strong className="text-white">Stripe</strong>.
                        </p>
                        <div className="grid gap-3 sm:grid-cols-2">
                            {[
                                { label: "Χρεώσεις", desc: "Προπληρωμή μηνιαία ή ετήσια. Τιμές χωρίς ΦΠΑ, εκτός αν ορίζεται διαφορετικά." },
                                { label: "Αυτόματη Ανανέωση", desc: "Ανανέωση εκτός αν ακυρωθεί 24+ ώρες πριν τη λήξη." },
                                { label: "Πολιτική Επιστροφών", desc: "Ολοκληρωμένες περίοδοι δεν επιστρέφονται, εκτός αναγκαστικού δικαίου." },
                                { label: "Τροποποίηση Τιμών", desc: "Με υποχρέωση ενημέρωσης 30 ημέρες πριν." }
                            ].map((item, i) => (
                                <div key={i} className="p-4 rounded-xl border border-white/5" style={{ background: "rgba(255,255,255,0.02)" }}>
                                    <h4 className="text-sm font-bold text-white mb-1">{item.label}</h4>
                                    <p className="text-xs text-slate-400 leading-relaxed">{item.desc}</p>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Section 5 */}
                    <section className="rounded-2xl border p-6 md:p-8" style={sectionStyle}>
                        <h2 className="text-lg font-bold mb-4 flex items-center gap-2" style={{ color: headingColor }}>
                            <span className="text-xs font-mono opacity-50 mr-1">05</span>
                            Περιορισμός Ευθύνης
                        </h2>
                        <p className="text-slate-300 leading-relaxed mb-4">
                            Η Orion Intelligence δηλώνει ότι το περιεχόμενο, τα προϊόντα και οι υπηρεσίες
                            παρέχονται μέσω του site <strong className="text-white">«ΩΣ ΕΧΟΥΝ»</strong> (as is).
                            Η Orion Intelligence καταβάλει κάθε δυνατή προσπάθεια να παρέχει υπηρεσίες υψηλής
                            ποιότητας, αλλά δεν εγγυάται ότι δεν θα υπάρξουν διακοπές, λάθη ή βλαπτικά
                            στοιχεία στα περιεχόμενα του διαδικτυακού τόπου.
                        </p>
                        <p className="text-slate-300 leading-relaxed mb-4">
                            Η Εταιρεία δεν ευθύνεται για οποιεσδήποτε ζημιές μπορούν να συμβούν στον
                            χρήστη/επισκέπτη, συμπεριλαμβανομένης και της απώλειας δεδομένων, εξαιτίας
                            καθυστερήσεων, διακοπής υπηρεσιών ή τεχνικών σφαλμάτων, για οποιαδήποτε αιτία.
                        </p>
                        <div className="p-4 rounded-xl border-l-4" style={{ borderColor: "#f59e0b", background: "rgba(245, 158, 11, 0.05)" }}>
                            <p className="text-sm text-slate-300 leading-relaxed">
                                Ειδικά για εφαρμογές σε στάδιο <strong className="text-white">«Beta»</strong> ή{" "}
                                <strong className="text-white">«Early Access»</strong>, η χρήση γίνεται με γνώση
                                ότι το προϊόν είναι υπό ανάπτυξη. Οι επισκέπτες συμφωνούν στη χρήση αυτού
                                με δική τους ευθύνη.
                            </p>
                        </div>
                    </section>

                    {/* Section 6 */}
                    <section className="rounded-2xl border p-6 md:p-8" style={sectionStyle}>
                        <h2 className="text-lg font-bold mb-4 flex items-center gap-2" style={{ color: headingColor }}>
                            <span className="text-xs font-mono opacity-50 mr-1">06</span>
                            Σύνδεσμοι προς Τρίτους (Links)
                        </h2>
                        <p className="text-slate-300 leading-relaxed">
                            Οποιαδήποτε αναφορά ή διασύνδεση (link) με άλλο site παρέχεται αποκλειστικά
                            για τη διευκόλυνση των χρηστών μας και η Orion Intelligence δεν είναι υπεύθυνη
                            για τα περιεχόμενα, τα προϊόντα και τις υπηρεσίες που παρέχονται στα site αυτά.
                        </p>
                    </section>

                    {/* Section 7 */}
                    <section className="rounded-2xl border p-6 md:p-8" style={sectionStyle}>
                        <h2 className="text-lg font-bold mb-4 flex items-center gap-2" style={{ color: headingColor }}>
                            <span className="text-xs font-mono opacity-50 mr-1">07</span>
                            Τροποποίηση Όρων
                        </h2>
                        <p className="text-slate-300 leading-relaxed">
                            Η Orion Intelligence διατηρεί το δικαίωμα να τροποποιεί ή να αναθεωρεί
                            ελεύθερα τους όρους και τις προϋποθέσεις, οποτεδήποτε το κρίνει αναγκαίο,
                            αναλαμβάνει δε την υποχρέωση να ενημερώνει τους επισκέπτες για οποιανδήποτε
                            μεταβολή, μέσα από τις σελίδες του παρόντος διαδικτυακού τόπου.
                        </p>
                    </section>

                    {/* Section 8 */}
                    <section className="rounded-2xl border p-6 md:p-8" style={sectionStyle}>
                        <h2 className="text-lg font-bold mb-4 flex items-center gap-2" style={{ color: headingColor }}>
                            <span className="text-xs font-mono opacity-50 mr-1">08</span>
                            Εφαρμοστέο Δίκαιο & Δικαιοδοσία
                        </h2>
                        <p className="text-slate-300 leading-relaxed">
                            Οι παρόντες όροι χρήσης συντάχθηκαν με βάση το σύνολο των κανόνων δικαίου,
                            τόσο τους ελληνικούς όσο και τους ευρωπαϊκούς και διεθνείς, και ερμηνεύονται
                            σύμφωνα με τους κανόνες της καλής πίστης, των συναλλακτικών ηθών και του
                            κοινωνικού και οικονομικού σκοπού του δικαιώματος. Σε περίπτωση κατά την
                            οποία όρος ή πρόβλεψη ήθελε κριθεί άκυρος ή ακυρώσιμος, η ακυρότητα αυτή
                            δεν επηρεάζει την ισχύ των λοιπών όρων. Αρμόδια δικαστήρια ορίζονται τα
                            δικαστήρια της <strong className="text-white">Χαλκιδικής</strong>.
                        </p>
                    </section>
                </motion.div>

                {/* Footer */}
                <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-slate-500">
                        © {new Date().getFullYear()} Orion Intelligence. All rights reserved.
                    </p>
                    <div className="flex gap-6 text-xs text-slate-500">
                        <Link to="/privacy" className="hover:text-white transition-colors">Πολιτική Απορρήτου</Link>
                        <Link to="/" className="hover:text-white transition-colors">Αρχική</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
